import type { JSX } from 'react';

import { Text } from '@change/ds-core-ui';

import type { PreviewEmailContentSubjectProps } from '../../../../../../types';

export function PreviewEmailContentSubject({ text }: PreviewEmailContentSubjectProps): JSX.Element {
	return (
		<div className="mb-2 px-4 lg:mb-4">
			<Text variant="heading" size="small" className="m-0 leading-6">
				{text}
			</Text>
		</div>
	);
}
